import { Link } from "react-router-dom";
import { Instagram, Facebook } from "lucide-react";
import { LOGO } from "../../lib/site";
import { MemberLoginAction } from "./MemberLogin";

const col = "text-sm text-[#B7C0CC]/80 hover:text-[#00C4F4] transition-colors duration-300";
const heading = { fontFamily: "var(--font-heading)" };

export const Footer = () => (
  <footer data-testid="site-footer" className="bg-[#020A12] border-t border-white/5">
    <div className="max-w-7xl mx-auto px-6 lg:px-8 pt-20 pb-10">
      <div className="grid grid-cols-2 lg:grid-cols-6 gap-x-8 gap-y-12">
        <div className="col-span-2">
          <img src={LOGO} alt="MST" className="h-12 w-auto" />
          <p className="mt-6 text-sm leading-[1.8] text-[#B7C0CC]/85 max-w-sm">
            MST is a private, invite-only network of entrepreneurs, investors, founders,
            professionals, and leaders building multiple streams of income and generational
            wealth together.
          </p>
        </div>

        <div>
          <h4 className="text-xs font-extrabold uppercase tracking-[0.2em] text-white mb-5" style={heading}>Quick Links</h4>
          <ul className="space-y-3">
            <li><Link className={col} to="/">Home</Link></li>
            <li><Link className={col} to="/about">About MST</Link></li>
            <li><Link className={col} to="/membership">Membership</Link></li>
            <li><Link className={col} to="/ecosystem">Ecosystem</Link></li>
            <li><Link className={col} to="/news">News</Link></li>
            <li><Link className={col} to="/contact">Contact</Link></li>
          </ul>
        </div>

        <div>
          <h4 className="text-xs font-extrabold uppercase tracking-[0.2em] text-white mb-5" style={heading}>Membership</h4>
          <ul className="space-y-3">
            <li><Link className={col} to="/apply" data-testid="footer-apply-link">Apply Now</Link></li>
            <li>
              <MemberLoginAction
                render={(p) =>
                  p.href
                    ? <a className={col} href={p.href} data-testid="footer-member-login-link">Member Login</a>
                    : <button type="button" className={`${col} text-left`} onClick={p.onClick} data-testid="footer-member-login-link">Member Login</button>
                }
              />
            </li>
            <li><Link className={col} to="/membership">Membership</Link></li>
            <li><Link className={col} to="/about">Governance</Link></li>
            <li><Link className={col} to="/membership-terms">MST Bylaws</Link></li>
          </ul>
        </div>

        <div>
          <h4 className="text-xs font-extrabold uppercase tracking-[0.2em] text-white mb-5" style={heading}>Resources</h4>
          <ul className="space-y-3">
            <li><Link className={col} to="/ecosystem">Masterclasses</Link></li>
            <li><Link className={col} to="/news">Events</Link></li>
            <li><Link className={col} to="/ecosystem">Business Resources</Link></li>
            <li><Link className={col} to="/ecosystem">Member Marketplace</Link></li>
            <li><Link className={col} to="/ecosystem">Tools &amp; Partners</Link></li>
          </ul>
        </div>

        <div className="col-span-2 sm:col-span-1 lg:col-span-1">
          <h4 className="text-xs font-extrabold uppercase tracking-[0.2em] text-white mb-5" style={heading}>Stay Connected</h4>
          <div className="flex gap-3">
            {[
              { Icon: Instagram, label: "Instagram", href: "https://www.instagram.com/multiplestreamteam" },
              { Icon: Facebook, label: "Facebook", href: "https://www.facebook.com/multiplestreamteam" },
            ].map(({ Icon, label, href }) => (
              <a
                key={label}
                href={href}
                target="_blank"
                rel="noopener noreferrer"
                aria-label={label}
                data-testid={`footer-social-${label.toLowerCase()}`}
                className="w-10 h-10 rounded-full border border-white/20 flex items-center justify-center text-[#B7C0CC] hover:text-white hover:border-[#009BFF] hover:bg-[#009BFF]/10 transition-colors duration-300"
              >
                <Icon size={17} strokeWidth={1.5} />
              </a>
            ))}
          </div>
        </div>
      </div>

      <div className="mt-16 pt-8 border-t border-white/10 flex flex-col md:flex-row items-center justify-between gap-4">
        <div className="flex flex-wrap gap-6 text-xs text-[#8996A6]" style={heading}>
          <Link to="/privacy" data-testid="footer-privacy-link" className="hover:text-white transition-colors duration-300">Privacy Policy</Link>
          <Link to="/terms" data-testid="footer-terms-link" className="hover:text-white transition-colors duration-300">Terms of Service</Link>
          <Link to="/membership-terms" data-testid="footer-membership-terms-link" className="hover:text-white transition-colors duration-300">Membership Terms</Link>
        </div>
        <p className="text-xs text-[#8996A6]">© 2026 Multiple Stream Team LLC. All Rights Reserved.</p>
      </div>
    </div>
  </footer>
);
